// extracted by mini-css-extract-plugin
export default {"list":"RecipesImagery_list__2c2WN","listItem":"RecipesImagery_listItem__W2evo","listItemContent":"RecipesImagery_listItemContent__kLcFS","image":"RecipesImagery_image__yLfwk"};